import { Component, OnInit, ChangeDetectorRef, AfterViewInit, ElementRef, ViewChild, Renderer2, Inject, PLATFORM_ID } from '@angular/core';

import { ActivatedRoute, Params, Router } from '@angular/router';
//import {DomSanitizer} from '@angular/platform-browser';
import { ContentService } from './services/content.service';
//import { StorageService } from '@citi-gcg-173875/citi-utils';
import { SvcServices } from './services';
import { windowService } from './services';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { styleConfig } from './app.styleConfig';
import { take, catchError } from 'rxjs/operators';
import { from } from 'rxjs';
import { E2eService } from './services/e2e.service';
import { BackendService } from './services/backend.service';
import { ScriptLoaderService } from './services/script-loader.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {

  constructor(
    private _route: ActivatedRoute,
    private router: Router,
    private _contentService: ContentService,
    private _svcService: SvcServices,
    private windowService: windowService,
    private _e2eService: E2eService,
    private backend: BackendService,
    private _changeDect: ChangeDetectorRef,
    private scriptLoader: ScriptLoaderService,
    //private _storageService: StorageService,
    private el: ElementRef,
    private _renderer: Renderer2,
    @Inject(DOCUMENT) private document,
    @Inject(PLATFORM_ID) private platformId: string
  ) { }

  branding: any;
  modalData: any;
  loaded: boolean = false;
  isShown: boolean = false;
  siteId: any;
  pageData: any;
  isBrowserSupportPage: boolean = false;
  ifBookmarkEnabled: any;
  showBrandValue: any;
  dynamicScripts = [];
  
  setStylesheet(qParams) {
    this.siteId = qParams.siteId.toLowerCase();
      for (var j = 0; j < styleConfig.partnerEnv.length; j++) {
        if (this.siteId == styleConfig.partnerEnv[j].siteId.toLowerCase()) {
          let a = this.document.getElementById('partnerStylesheet');
          let b = this.document.getElementById('partnerIcon');
          if(this.router.url.startsWith("/supported-browsers")){
            this._renderer.setAttribute(a, 'href', 'assets/uicontainerBuild/css/' + styleConfig.partnerEnv[j].styleName + '/' + styleConfig.partnerEnv[j].styleName + '.css');
          } else {
            this._renderer.setAttribute(a, 'href', 'assets/css/' + styleConfig.partnerEnv[j].styleName + '/' + styleConfig.partnerEnv[j].styleName + '.css');
          }
         }
      }
  }
  
  @ViewChild('overlay') overlay: ElementRef;
  ngOnInit() {
    let siteIdVar ='';
    let brandIdVar = '';

    this.scriptLoader
      .loadScript('https://securepubads.g.doubleclick.net/tag/js/gpt.js')
      .then(() => {
        console.log('GPT script loaded successfully');
      })
      .catch((error) => {
        console.error(error);
      });

      // delete CAT Cookie to avoid issue
      this.deleteCookies();

    this._route.queryParams.subscribe((qParam: Params) => {
      if (Object.keys(qParam).length > 0) {

        /*When running ng serve locally, there is no server side style added
        Do not commit this change to higher environment. Only for local use.*/
        //  if(this.windowService.nativeWindow.location.host === "localhost:4200"){
        //   this.setStylesheet(qParam);
        // }
       
        this.isBrowserSupportPage = this.router.url.startsWith("/supported-browsers");
        if(qParam && qParam.siteId.toLowerCase() === 'cacn_homedepot'){
          if(qParam.langId === 'fr_CA'){
            localStorage.setItem("siteLocal_ID", 'fr_CA');
            this.el.nativeElement.parentElement.parentElement.setAttribute('lang', 'fr');
          } else if(qParam.langId === 'fr_US'){
            localStorage.setItem("siteLocal_ID", 'fr_US');
            this.el.nativeElement.parentElement.parentElement.setAttribute('lang', 'fr');
          } else if(qParam.langId === 'en_US'){
            localStorage.setItem("siteLocal_ID", 'en_US');
            this.el.nativeElement.parentElement.parentElement.setAttribute('lang', 'ca');
          } else {
            localStorage.setItem("siteLocal_ID", 'en_CA');
            this.el.nativeElement.parentElement.parentElement.setAttribute('lang', 'ca');
          }
        } else if(qParam && qParam.langId) {
          localStorage.setItem("siteLocal_ID", qParam.langId);
          const langAttr = (qParam.langId === 'en_US') ? 'en' : 'es';
          this.el.nativeElement.parentElement.parentElement.setAttribute('lang', langAttr);
        } else {
          localStorage.setItem("siteLocal_ID", "en_US");
          this.el.nativeElement.parentElement.parentElement.setAttribute('lang','en')
        }
     
        if (qParam && qParam.brandId) {
          const newBrandId = qParam.brandId.toLowerCase();
        
          // Check if the brandId has changed
          if (this.showBrandValue !== newBrandId) {
            console.log('BrandId changed from', this.showBrandValue, 'to', newBrandId);
        
            this.showBrandValue = newBrandId;
            brandIdVar = this.showBrandValue;
        
            this._contentService.clearCache(); 
            this._svcService.clearCache(); 
            
            this._svcService.setParams(qParam);
            this._contentService.setParams(qParam);
          }
        } else {
          this.showBrandValue = '';
          brandIdVar = this.showBrandValue;
        }
        
        // Always update siteId
        siteIdVar = qParam.siteId.toLowerCase();
        console.log('Updated siteId:', siteIdVar);
        
        // Set parameters in services
        this._svcService.setParams(qParam);
        this._contentService.setParams(qParam);
        this._contentService.setParams(qParam);

        // BBY and THD SSO Changes
        const ssopartner = ['plcn_bestbuy', 'plcn_homedepot'];
        if(qParam.pageName === 'ssoauthenticate' && !!qParam.partnerUserId && ssopartner.includes(qParam.siteId.toLowerCase())) {
          sessionStorage.setItem("ssoPartnerUserId", qParam.partnerUserId);
          sessionStorage.setItem("ssoPartnerRedirectUrl", qParam.partnerRedirectUrl);
          sessionStorage.setItem("ssoState", qParam.state);
          const redirectUrl = `${window.location.origin}/RSauth/signon?pageName=singlesignon&siteId=${qParam.siteId}&langId=en_US`;
          window.location.href = redirectUrl;
        }
         // Dillards SSO Changes
        else if (qParam.pageName === 'ssoauthenticate' && !!qParam.partnerUserId && !!qParam.request_uri) {
          // logout current session, when initialize signon page
          this.backend.delete("logout", {}, {})
          .pipe(
            catchError((error) => {
              return from([{ error }]);
            })
          ).subscribe((data) => {
            console.log("app component pagename ssoauthenticate start");
            this._svcService.getAuthorizeToken().subscribe(() => { });  
            console.log("app component pagename ssoauthenticate end");
          });
        } else if (qParam.pageName.toLowerCase() === 'signon') { // normal signon page
          if(!this._e2eService.e2eConfig){
            this._e2eService.getE2eConfig().subscribe(() => { });  
          }
          
          if(!this._e2eService.sRKeyVal){
            // logout current session, when initialize signon page
            this.backend.delete("logout", {}, {})
              .pipe(
                catchError((error) => {
                  return from([{ error }]);
                })
              ).subscribe((data) => {
                this.backend.bizToken = ""; //empty biz token so that new session is initiated
                this._e2eService.initE2e().subscribe(() => {}); //get new token for encryption
              });
          }
        }

        

        if(this.isBrowserSupportPage){

          if(qParam.siteId == undefined || qParam.siteId == "" ){
            this.router.navigate(['**'], { skipLocationChange: true })
          } else {
              var paramsModified = JSON.parse(JSON.stringify(qParam))
              paramsModified.pageName = "browser"; //set default pagename to browser if not present
              this._svcService.setParams(paramsModified);
              this._contentService.setParams(paramsModified);
          }
        } else if(qParam.siteId == undefined || qParam.siteId == ""  || qParam.pageName =="" || qParam.pageName == undefined){
          this.router.navigate(['**'], { skipLocationChange: true });
        }else{        
          this.siteId = qParam.siteId.toLowerCase();
          if(!["plcn_staples","plcn_cat","plcn_brooksbrothers","ploc_wawa","plcn_kawa","plcn_officedepot","plcn_servicecentral","plcn_llbean", "plcn_meijer", "plcn_wfcc","plcn_cpay","plcn_ostk","plcn_dillards","plcn_tractorsupply","ploc_shell","plcn_brandsource","plcn_jewelry","ploc_sunoco","ploc_exxonmobil","plcn_goodyear","goodyear","plcn_drivecard","plcn_home","plcn_elecappl","plcn_bestbuy", "plcn_homedepot", "cacn_homedepot", "plcn_syw", "sears","plcn_lincolnservices", "plcn_service", "plcn_toro","plcn_brp", "plcn_costco", "plcn_hnpe", "plcn_hnps"].includes(this.siteId) || !["signon", "singlesignon", "ssoauthenticate"].includes(qParam.pageName)){
            this.router.navigate(['**'], { skipLocationChange: true });
          }
        }
        this._contentService.getBrandingContent()
        .subscribe((data) => {
          if (data !== null && data !== undefined) {
            this.pageData = (data.value) ? data.value.content.CARDS : data.content.CARDS;
            if(this.pageData){ 
              this.ifBookmarkEnabled = (this.pageData.copy$$bookmark_enabled) ? this.pageData.copy$$bookmark_enabled.TEXT : false;
              console.log("-----------------------------");
              console.log(siteIdVar);
              console.log(brandIdVar);
              if(this.ifBookmarkEnabled == "true" && this.isBrowserSupportPage === false){
                  this.loadScriptforBookmark(siteIdVar,brandIdVar);
              }
            }
          }
          if(this.pageData && this.pageData.copy$$enable_MIL && this.pageData.copy$$enable_MIL.TEXT==='true'){
            if(qParam.langId && qParam.brandId && qParam.siteId) {
              if(qParam.siteId.toLowerCase() === 'plcn_cpay'  && qParam.brandId.toUpperCase() === 'MIL' && qParam.langId.toUpperCase() === 'ES_US'){
                this.router.navigate(['**'], { skipLocationChange: true });
              }
            }
          }
        });

        this._contentService.getModalContent("jCARDS_svc_cw_modals")
        .subscribe((data) => {
        });        

        
        this._svcService.isSignOnLoaded.subscribe((data)=>{
          if(data !== undefined && data !== null){
            if(data){
              this._renderer.removeChild(this, this.overlay.nativeElement);
            }
          }
        });
      }
    });
  }

  ngAfterViewInit() {
    this._contentService.componentLoaded.subscribe((data) => {
      this.loaded = data;
      this._changeDect.detectChanges();
    });

  }
	public loadScriptforBookmark(siteIdArg, brandIdArg) {
    if (isPlatformBrowser(this.platformId)) {
      var isIOSorAndroid = /android|iPhone/i.test(this.windowService.nativeWindow.navigator.userAgent);
      if(isIOSorAndroid){
        if(siteIdArg === "plcn_wfcc" && brandIdArg){
        var tags = document.createElement("script");
        tags.src = "assets/manifests/"+brandIdArg+"/a2hs.js";
        }
        else  {
        var stylePartner= siteIdArg.split("_");
        stylePartner=stylePartner[stylePartner.length-1];
        var tags = document.createElement("script");
        tags.src = "assets/manifests/"+stylePartner+"/a2hs.js";
        }
        tags.async = true;
        tags.type = "text/javascript";
        document.getElementsByTagName("head")[0].appendChild(tags);

      var browserLanguage= this.windowService.nativeWindow.navigator.language;
        if(browserLanguage != undefined){
          browserLanguage=browserLanguage.toLowerCase();
          if(/en/i.test(browserLanguage)){
            browserLanguage="en";
          }else if(/es/i.test(browserLanguage)){
            browserLanguage="es";
          }else{
            browserLanguage = "en";
          }
        }else{
          browserLanguage = "en";
        }
        if(brandIdArg) {
          let dynamicScripts = [
            {name: 'manifest', href: 'assets/manifests/'+brandIdArg+'/lib/manifest.'+browserLanguage+'.json'},
            {name: 'apple-touch-icon', href : 'assets/manifests/'+brandIdArg+'/bookmark_icons/icon_152_ios.png', sizes: '152x152'},
            {name: 'apple-touch-icon', href : 'assets/manifests/'+brandIdArg+'/bookmark_icons/icon_120_ios.png', sizes: '120x120'},
            {name: 'apple-touch-icon', href : 'assets/manifests/'+brandIdArg+'/bookmark_icons/icon_76_ios.png', sizes: '76x76'},
            {name: 'apple-touch-icon', href : 'assets/manifests/'+brandIdArg+'/bookmark_icons/icon_60_ios.png', sizes: '60x60'}
          ];
          for (let i = 0; i < dynamicScripts.length; i++) {
            var link = document.createElement('link');
            link.rel = dynamicScripts[i].name;
            link.href = dynamicScripts[i].href;
            document.getElementsByTagName( "head" )[0].appendChild(link);
          }
        }    
        else {
          let dynamicScripts = [
            {name: 'manifest', href: 'assets/manifests/'+stylePartner+'/lib/manifest.'+browserLanguage+'.json'},
            {name: 'apple-touch-icon', href : 'assets/manifests/'+stylePartner+'/bookmark_icons/icon_152_ios.png', sizes: '152x152'},
            {name: 'apple-touch-icon', href : 'assets/manifests/'+stylePartner+'/bookmark_icons/icon_120_ios.png', sizes: '120x120'},
            {name: 'apple-touch-icon', href : 'assets/manifests/'+stylePartner+'/bookmark_icons/icon_76_ios.png', sizes: '76x76'},
            {name: 'apple-touch-icon', href : 'assets/manifests/'+stylePartner+'/bookmark_icons/icon_60_ios.png', sizes: '60x60'}
          ];
          for (let i = 0; i < dynamicScripts.length; i++) {
            var link = document.createElement('link');
            link.rel = dynamicScripts[i].name;
            link.href = dynamicScripts[i].href;
            document.getElementsByTagName( "head" )[0].appendChild(link);
          }
        }
      }
    }
  }

  getStyleName(siteId){
    siteId = siteId.toLowerCase();
      for (var j = 0; j < styleConfig.partnerEnv.length; j++) {
        if (siteId == styleConfig.partnerEnv[j].siteId.toLowerCase()) {
          return styleConfig.partnerEnv[j].styleName;
         }
      }
  }

  deleteCookies() {
    let cookiesArray = document.cookie;
    if (cookiesArray != null && cookiesArray != "" && cookiesArray != undefined) {
      // delete citi_authorization in cookies
      document.cookie = "citi_authorization=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.citibank.com";
      console.log("cat cookie deleted");
    }
  }

}

